import type { ICountryFilter, ICurrencyFilter, IGroupFilter, IStagFilter } from './filters';
import type { ILink } from './links';
import type { IStrapiImage } from './strapiImage';

export enum EPopupName {
  loader = 'loader',
  privacyPolicy = 'privacyPolicy',
  newPrivacyPolicy = 'newPrivacyPolicy',
  mobileBurgerMenu = 'mobileBurgerMenu',
  promoLoader = 'promoLoader',
  sendMessagePopup = 'sendMessagePopup',
}

export enum EPopupPosition {
  Right = 'right',
  Left = 'left',
  Top = 'top',
  Bottom = 'bottom',
  Center = 'center',
}

export enum EPopupTermsType {
  Katsubet = 'katsubet',
  Mirax = 'mirax',
}

export interface ICrossSalePopupData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  position: number;
  visiblePosition: EPopupPosition;
  writableGroupId: string;
  bannerMobile: IStrapiImage;
  bannerDesktop: IStrapiImage;
  countries: ICountryFilter;
  currencies: ICurrencyFilter;
  groups: IGroupFilter;
  stags: IStagFilter;
  action: ILink;
  stageOnly: boolean;
  appearDelay?: number;
  termsType?: EPopupTermsType;
  groupToAddOnReg?: string;
  isAvailableInGamePage?: boolean;
  isAvailableInCashier?: boolean;
}

export interface ICrossSalePopupStrapiResponse {
  data: ICrossSalePopupData[];
}
